import React from 'react'
import { PublicNavBar as PublicNavBarBase } from 'assets/lib'
import { withPortalThemeLegacy } from 'modules/utils';

// publics nav bar - bar as a service example
const PublicNavBar = (props) => withPortalThemeLegacy(PublicNavBarBase, props)

const data = {
  links: [],
  social: [
    {
      title: 'Notícias',
      ariaLabel: 'Notícias',
      url: 'https://www.ua.pt/pt/noticias',
      target: '_blank',
      onlyIcon: false,
      styles: {
        fontWeight: '400',
        fontDecoration: 'none'
      }
    },
    {
      title: 'Agenda',
      ariaLabel: 'Agenda',
      url: 'https://www.ua.pt/pt/agenda',
      target: '_blank',
      onlyIcon: false,
      styles: {
        fontWeight: '400',
        fontDecoration: 'none'
      }
    },
    {
      url: 'https://www.facebook.com/universidadedeaveiro/',
      target: '_blank',
      ariaLabel: 'Facebook',
      onlyIcon: true,
      styles: {
        fontWeight: '400',
        fontDecoration: 'none'
      }
    },
    {
      url: 'https://www.instagram.com/universidadedeaveiro/',
      target: '_blank',
      ariaLabel: 'Instagram',
      onlyIcon: true,
      styles: {
        fontWeight: '400',
        fontDecoration: 'none'
      }
    }
  ],
  auth: {
    styles: {
      fontWeight: '400'
    },
    iconLogOut: {
      name: 'fas fa-user',
      cursor: 'cursor',
      fontSize: '12px',
      marginLeft: '12px'
    },
    iconLogIn: {
      name: 'fas fa-user',
      cursor: 'cursor',
      fontSize: '12px',
      marginLeft: '12px'
    }
  }
}


const NavPublics = () => (
  <PublicNavBar {...data} isLogin />
)

export default NavPublics
